import { render, staticRenderFns } from "./AutoField.vue?vue&type=template&id=346a0f76&"
import script from "./AutoField.vue?vue&type=script&lang=js&"
export * from "./AutoField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports